import React__default from 'react';
import { useTheme } from 'styled-components';
function useCookieConsentStyle() {
  var theme = useTheme();
  return React__default.useMemo(function () {
    return {
      textColor: theme.colors.textPrimary,
      backgroundColor: theme.colors.modalBackground,
      acceptButtonDisplay: true,
      acceptButtonColor: theme.colors.green[300],
      closeButtonRejects: true,
      rejectButtonColor: theme.colors.grey[5],
      rejectButtonCaptionColor: theme.colors.textPrimary,
      customizeButtonDisplay: true,
      customizeButtonColor: theme.colors.grey[5],
      customizeButtonCaptionColor: theme.colors.textPrimary,
      position: "float-bottom-center",
      rejectButtonDisplay: true
    };
  }, [theme.colors.green, theme.colors.grey, theme.colors.modalBackground, theme.colors.textPrimary]);
}
export { useCookieConsentStyle };